import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@/hooks";

type RequireAdminRoleProps = {
  children: ReactNode;
};

export function RequireAdminRole({ children }: RequireAdminRoleProps) {
  const { user } = useAuth();
  const isAdmin = user?.roles?.some((role) => role.name === "admin") ?? false;

  return isAdmin ? children : <Navigate to="/" replace />;
}
